import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import apiClient from '../api/client'

function ProtectedRoute(): JSX.Element {
  const [checked, setChecked] = useState(false)
  const [authed, setAuthed] = useState(false)

  useEffect(() => {
    apiClient
      .get('/auth/me')
      .then(() => {
        setAuthed(true)
        setChecked(true)
      })
      .catch(() => {
        setAuthed(false)
        setChecked(true)
      })
  }, [])

  if (!checked) return <div style={{ padding: 24 }}>Checking session...</div>
  if (!authed) return <Navigate to="/login" replace />
  return <Outlet />
}

export default ProtectedRoute
